import React, { useState } from 'react';
import dateFormat from 'dateformat';
import { Button, Modal } from "react-bootstrap";
import UpdateHackInternBatch from '../../components/modals/UpdateHackInternBatch';
import { Close, Delete, Edit, MoreVert } from '@material-ui/icons'
import { Dropdown } from 'react-bootstrap'
import axios from 'axios';
import ENDPOINT from '../../context/EndPoint';
import SecurityHeaders from '../../context/SecurityHeaders';
import DeleteModal from '../../components/modals/DeleteModal';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import { useDispatch } from 'react-redux';

const HackingInternshipBatchItem = ({ item, reload }) => {

  const dispatch = useDispatch()
  // Function to determine the class based on slot status
  const getSlotClass = (status) => {
    if (status === "Almost filled") return "text-danger";
    if (status === "Few seats left") return "text-primary";
    if (status === "Available") return "text-success";
    return "";
  };
   const [open, setOpen] = useState({
      open: false,
      message: '',
    type: ''
  
    });
  const [modelShow, setModelShow] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const deleteBatch = async () => {
    dispatch({type:'LOADING'})
  const data  = new FormData();
  data.append('internship_id', item.internship_id);
try{
  const response = await axios.post(ENDPOINT+"delete-hacking-internship-batch.php",data,SecurityHeaders)
  if (response.data.status === "success") {
    setDeleteConfirmation(false);
    dispatch({type:'DONE_LOADING'})

    reload();
    setOpen({ open: true, message: response.data.message, type:'success' });
  } else {
 dispatch({type:'ERROR',payload:response.data.message})
  }
}
catch(err) {
  dispatch({type:'ERROR',payload:err.message})
}
};


  return (
    <>
    <SnackbarToast open={open} handleClose={()=>setOpen((pre)=>({...pre,open:false}))} />

    <DeleteModal show={deleteConfirmation} HandleClose={()=>setDeleteConfirmation(false)} HandleDelete={deleteBatch} />

      <Modal show={modelShow} onHide={() => setModelShow(false)}>
        <Modal.Body>
          <UpdateHackInternBatch batch={item} reload={reload} handelClose={() => setModelShow(false)} />
        </Modal.Body>
      </Modal>
      <div className="col-lg-4 col-md-4 col-sm-12 col-12 p-2">
        <div className="border border-3 br-5">
          <div className="bg-dark rounded-top hacking-line2 text-light p-3 d-flex justify-content-between ">
            <div>
              <h3 className="mb-0 text-light">{item.batch_name}</h3>
              <p className="text-light mt-2">
                <b>Batch Starts:</b> {dateFormat(item.start_date, 'dd mmm yyyy')}
              </p>
            </div>
          <div className='me-4'>
          <Dropdown className="options-dropdown position-absolute "  >
              <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
                <MoreVert className="text-dark" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setModelShow(true)}   >
                  <Edit /> Update
                </Dropdown.Item>
                <Dropdown.Item onClick={()=>setDeleteConfirmation(true)} className='text-danger'   >
                  <Delete /> Delete
                </Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>
          </div>

          </div>
          <div className="p-3">
            <p>Registration Ends: {dateFormat(item.start_date, 'dd mmm yyyy')}</p>

            <div className="d-flex align-items-center mt-1 mb-1">
              <h6 className="mb-0 pb-0 me-2">Morning Slot:</h6>
              <h6 className={`${getSlotClass(item.morning_slot)} mb-0 pb-0`}>{item.morning_slot}</h6>
            </div>

            <div className="d-flex align-items-center mt-2 mb-1">
              <h6 className="mb-0 pb-0 me-2">Afternoon Slot:</h6>
              <h6 className={`${getSlotClass(item.afternoon_slot)} mb-0 pb-0`}>{item.afternoon_slot}</h6>
            </div>

            <div className="d-flex align-items-center mt-1 mb-1">
              <h6 className="mb-0 pb-0 me-2">Evening Slot:</h6>
              <h6 className={`${getSlotClass(item.evening_slot)} mb-0 pb-0`}>{item.evening_slot}</h6>
            </div>
          </div>
        </div>
      </div></>
  );
};

export default HackingInternshipBatchItem;
